import { hasClientSession } from '../services/session';
// audit-safety-integrated
import { readJson } from '../utils/auditSafety';
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DeletePc from "./DeletePc";
import { API_BASE_URL } from '../services/api';
const DeletePurchaseConfirmationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(true);
  const [pcDocument, setPcDocument] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const { indentId, remarks, notificationId } = location.state || {};

  useEffect(() => {
    setSuccess(false);
    setErrorMsg("");
    setPcDocument("");
    setShowModal(true);
    if (indentId) {
      fetchIndentDetail(indentId);
    }
  }, [indentId, notificationId]);

const fetchIndentDetail = async (id) => {
  try {
    setLoading(true);
    const sessionAvailable = hasClientSession();
    if (!sessionAvailable) return;

    // ✅ Fetch approved indent list
    const response = await fetch(
      `${API_BASE_URL}/indent/approved/list`,
      {
        headers: {

          "Content-Type": "application/json",
        },
      }
    );

    const data = await readJson(response);

    if (!data.error && Array.isArray(data.data)) {
      // ✅ Find matching indent by ID
      const matchingIndent = data.data.find(
        (item) => String(item.id) === String(id)
      );

      if (matchingIndent && matchingIndent.uploaded_pc) {
        setPcDocument(matchingIndent.uploaded_pc);
      } else {
        void 0;
        setPcDocument("");
      }
    }
  } catch (err) {
    void 0;
  } finally {
    setLoading(false);
  }
};


  const handleClose = () => {
    setShowModal(false);
    navigate(-1);
  };

  const markNotificationAsRead = async (notificationId) => {
    try {
      const sessionAvailable = hasClientSession();
      if (!sessionAvailable) return;

      await fetch(
        `${API_BASE_URL}/notifications/${notificationId}/read`,
        {
          method: "PUT",
          headers: {

            "Content-Type": "application/json",
          },
        }
      );
    } catch (err) {
      void 0;
    }
  };

  const handleConfirm = async (editedRemarks) => {
    try {

      const response = await fetch(
        `${API_BASE_URL}/indent/${indentId}/pc-del`,
        {
          method: "DELETE",
          headers: {

            "Content-Type": "application/json",
          },
          body: JSON.stringify({ remarks: editedRemarks }),
        }
      );

      if (response.ok) {
        if (notificationId) {
          await markNotificationAsRead(notificationId);
        }
        setShowModal(false);
        setSuccess(true);
        setTimeout(() => navigate(-1), 2000);
      } else {
        const errorData = await readJson(response);
        setErrorMsg(`Failed to delete PC: ${errorData.message || "Unknown error"}`);
      }
    } catch (err) {
      void 0;
      setErrorMsg("An error occurred while deleting the PC");
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-gray-500">Loading PC document...</div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <svg className="w-16 h-16 text-green-500 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h2 className="text-2xl font-bold text-gray-800">PC Deleted Successfully</h2>
          <p className="text-gray-500 mt-2">Redirecting back...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {errorMsg && (
        <div className="fixed top-4 right-4 z-50 bg-red-50 border border-red-200 text-red-700 px-4 py-2 rounded-lg shadow text-sm">
          {errorMsg}
        </div>
      )}
      <DeletePc
        open={showModal}
        onClose={handleClose}
        onConfirm={handleConfirm}
        pcDocument={pcDocument}
        remarks={remarks}
        readOnlyRemarks={true}
      />
    </>
  );
};

export default DeletePurchaseConfirmationPage;
